import { render, staticRenderFns } from "./CategorySwipers.vue?vue&type=template&id=3a7dbcf9&scoped=true&"
import script from "./CategorySwipers.vue?vue&type=script&lang=js&"
export * from "./CategorySwipers.vue?vue&type=script&lang=js&"
import style0 from "./CategorySwipers.vue?vue&type=style&index=0&id=3a7dbcf9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7dbcf9",
  null
  
)

export default component.exports